module.exports = __webpack_public_path__ + "img/hanukiah.35976478.svg";